
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { HttpModule } from '@angular/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';

import { MatInputModule, MatAutocompleteModule, MatSlideToggleModule, MatIconModule, MatButtonModule, MatDialogModule, MatSnackBarModule } from '@angular/material';

import { HeaderComponent } from './header.component';

import { HeaderService } from './header.service';

@NgModule({
    imports: [
        BrowserModule, FormsModule, ReactiveFormsModule, BrowserAnimationsModule, CommonModule, BrowserModule, FormsModule, HttpModule,
        MatInputModule, MatAutocompleteModule, MatSlideToggleModule, MatIconModule, MatButtonModule, MatDialogModule, MatSnackBarModule,
        RouterModule
    ],
    entryComponents: [],
    exports: [
        HeaderComponent
    ],
    declarations: [
        HeaderComponent
    ],
    providers: [ HeaderService ],
    bootstrap: []
})
export class HeaderModule {
}
